// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3RiRN","info":"Note_info__19TgN","note":"Note_note__3lw_n","actions":"Note_actions__2cXYC"};